import { Skeleton } from "~/components/ui/skeleton";

const Skeletons = ({ size = 20 }: { size?: number }) => {
  return new Array(size).fill(0).map((_, i) => (
    <div
      key={i}
      className="flex h-[400px] w-1/2 p-0 px-2 py-6 sm:px-6 md:w-1/3 xl:w-1/4"
    >
      <Skeleton className="h-full w-full" aria-label="Loading product" />
    </div>
  ));
};
const SkeletonsFilters = () => {
  return (
    <>
      <Skeleton
        key={"results-number"}
        className="mb-6 mt-1 h-6 w-24"
        aria-label="Loading product count"
      />
      <div className="flex w-full flex-wrap items-center justify-between gap-2 md:hidden">
        <Skeleton
          key={"1"}
          className="h-6 w-52"
          aria-label="Loading filter option"
        />
        <Skeleton
          key={"2"}
          className="h-6 w-52"
          aria-label="Loading filter option"
        />
      </div>
      <div className="hidden w-full flex-wrap items-center gap-2 md:flex">
        {new Array(6).fill(0).map((_, i) => (
          <Skeleton
            key={i}
            className="h-6 w-24"
            aria-label="Loading filter option"
          />
        ))}
      </div>
    </>
  );
};

export { Skeletons, SkeletonsFilters };
